// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

localStorage.token = 'EAACW5Fg5N2IBAGZCd0NIOZAZCD3JXDaRJQ5EbZBiM8huEXguBGs2D83KDDwcuOIBJ8CSco52mG3nsmxgM6IlkwDRs0Dd8JXybyEK9ffYZC5fdr8wvq5YVCD20uQ0jKvWpEBDf5ZCiZCyrazMysOarIj0F20LUoFiy07KMyLM9k0i6nQUjfMiFbHwzdypsC8zeIZD'
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js